import { useCallback, useContext, useEffect, useRef, useState } from "react";
import StoreContext from "../context/store";
import { CartContext } from "../context/CartProvider";
import { isBrowser } from "@helpers/browser";
import useDeviceDetect from "./useDeviceDetect";

function useSticky(isHeader = false, topOffset = "0px") {
  const { isMobile } = useDeviceDetect();
  const { displayAB, hideOnScrollLogo } = useContext(StoreContext);
  const { cart } = useContext(CartContext);
  const [offset, setOffset] = useState({});
  const mobileRef = useRef(isMobile);

  const updateOffset = useCallback(() => {
    const abHeight = displayAB
      ? document?.querySelector("#announcement-bar")?.offsetHeight || 0
      : 0;
    const headerLogoHeight = document?.querySelector("#header-logo")?.offsetHeight || 0;
    const headerHeight =
      (document?.querySelector("#header")?.offsetHeight || 0) -
      (hideOnScrollLogo ? headerLogoHeight : 0);

    setOffset({
      position: "sticky",
      top: isHeader
        ? `${abHeight - headerLogoHeight}px`
        : `calc(${headerHeight}px + ${abHeight}px + ${topOffset})`,
    });
  }, [displayAB, hideOnScrollLogo, isHeader, topOffset]);

  useEffect(() => {
    // if isMobile changed from previous value we delay the update by the time of the AB animation (300ms)
    // to avoid taking height measurements in the middle of the animation
    if (mobileRef.current !== isMobile) {
      setTimeout(() => {
        mobileRef.current = isMobile;
        updateOffset();
      }, 300);
    } else {
      updateOffset();
    }
  }, [updateOffset, cart, isMobile]);
  // cart dependency needed because AB changes when cart updates
  // isMobile dependency needed because header height changes on mobile

  if (!isBrowser) {
    return null;
  }

  return offset;
}

export default useSticky;
